import React, { createContext, useContext, useEffect, useState } from 'react';
import { globals } from '../globals';

const UserContext = createContext();

export function UserProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [cookieConsent, setCookieConsent] = useState(false);

 
useEffect(() => {
  const consent = localStorage.getItem('cookieConsent');
  if (consent === 'true') {
    setCookieConsent(true);
  }
}, []);

useEffect(() => {
  const storedUser =
    localStorage.getItem('user') || sessionStorage.getItem('user');

  if (storedUser) {
    setUser(JSON.parse(storedUser));
    setLoading(false);
    return;
  }

  if (!cookieConsent) {
    setLoading(false);
    return;
  }

  fetch(globals.homepageUrl + '/php/me.php', {
    method: 'GET',
    credentials: 'include',
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.authenticated) {
        setUser(data.user);
      }
      setLoading(false);
    })
    .catch(() => setLoading(false));
}, [cookieConsent]);


  // Login utente
  const login = async (email, password, remember) => {
    const response = await fetch(globals.homepageUrl + '/php/login.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ email, password }),
    });

    const data = await response.json();

    if (data.success) {
      setUser(data.user);

      // 🔐 Salva nel tipo di storage corretto
      const storage = remember ? localStorage : sessionStorage;
      storage.setItem('user', JSON.stringify(data.user));

      return { success: true };
    } else {
      return { success: false, message: data.message };
    }
  };


  // Logout utente
  const logout = async () => {
    await fetch(globals.homepageUrl + '/php/logout.php', {
      method: 'GET',
      credentials: 'include',
    });
    setUser(null);
    localStorage.removeItem('user');
    sessionStorage.removeItem('user');
  };

  // Salva il consenso ai cookie
  const giveCookieConsent = () => {
    localStorage.setItem('cookieConsent', 'true');
    setCookieConsent(true);
  };

  return (
  <UserContext.Provider
    value={{
      user,
      setUser,
      login,
      logout,
      loading,
      cookieConsent, 
      giveCookieConsent,
      hasCookieConsent: () => cookieConsent,
    }}
  >
    {children}
  </UserContext.Provider>
);
}

export function useUser() {
  return useContext(UserContext);
}
